const STORAGE_KEY = 'tagnize_upload_queue_v1';
const MAX_ITEMS = 5;
const QUEUE_TZ = 'America/Argentina/Buenos_Aires';

/** Calendar date YYYY-MM-DD in Argentina (aligned with server queue_date). */
export function todayKeyART() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: QUEUE_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/** @returns {Array<object>} persisted queue rows (sin File) for the given tenant */
export function loadUploadQueue(tenantId = '') {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    if (data.date !== todayKeyART()) {
      localStorage.removeItem(STORAGE_KEY);
      return [];
    }
    if (tenantId) {
      if (!data.tenantId) {
        localStorage.removeItem(STORAGE_KEY);
        return [];
      }
      if (data.tenantId !== tenantId) {
        return [];
      }
    }
    return (data.items || []).slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

/** Persiste los últimos 5 ítems del día (metadata solamente, cache local). */
export function saveUploadQueue(items, queueDate = todayKeyART(), tenantId = '') {
  if (!tenantId) return;
  try {
    const serializable = items
      .slice(0, MAX_ITEMS)
      .map(({ file, ...rest }) => rest);
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        date: queueDate,
        tenantId,
        items: serializable,
        serverSyncedAt: new Date().toISOString(),
      }),
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearUploadQueue() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export { MAX_ITEMS as UPLOAD_QUEUE_MAX_ITEMS };
